import * as Types from 'app-redux/collectionV2/actions/types'

import { generateInitialState } from 'app-redux/collectionV2/initialState'

import { CollectionV2Actions } from 'app-redux/collectionV2/actions'

import { CollectionV2State } from 'app-redux/collectionV2/types'

import { writeChangesToCookies } from 'app-redux/collectionV2/helpers/cachedValues'

const handler = (state = generateInitialState(), action: CollectionV2Actions): CollectionV2State => {
  switch (action.type) {
    case Types.SET_COLLECTION_V2_STATE:
      writeChangesToCookies(action.payload)

      return { ...state, ...action.payload }

    default:
      return state
  }
}

export default handler
